/* Preiswerk theme scripts */
(function(){
  function pad(n){return String(n).padStart(2,'0');}
  function tick(el){
    var end = parseInt(el.getAttribute('data-countdown'),10);
    if(!end){return;}
    function render(){
      var diff = Math.max(0, end - Math.floor(Date.now()/1000));
      el.textContent = pad(Math.floor(diff/3600))+':'+pad(Math.floor((diff%3600)/60))+':'+pad(diff%60);
      if(diff<=0){clearInterval(el._iv);}
    }
    render();
    el._iv = setInterval(render,1000);
  }
  document.querySelectorAll('[data-countdown]').forEach(tick);

  /* Daily countdown to local midnight (0 Uhr), auto-resets */
  function nextMidnight(){ var d=new Date(); d.setHours(24,0,0,0); return d.getTime(); }
  document.querySelectorAll('[data-countdown-midnight]').forEach(function(el){
    var target = nextMidnight();
    function render(){
      var diff = Math.floor((target - Date.now())/1000);
      if(diff <= 0){ target = nextMidnight(); diff = Math.floor((target - Date.now())/1000); }
      el.textContent = pad(Math.floor(diff/3600))+':'+pad(Math.floor((diff%3600)/60))+':'+pad(diff%60);
    }
    render();
    setInterval(render,1000);
  });

  /* Slide-in drawer */
  var drawer = document.getElementById('MainDrawer');
  if(drawer){
    function open(){ drawer.classList.add('is-open'); document.body.style.overflow='hidden'; }
    function close(){ drawer.classList.remove('is-open'); document.body.style.overflow=''; }
    document.querySelectorAll('[data-drawer-open]').forEach(function(b){ b.addEventListener('click',open); });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function(b){ b.addEventListener('click',close); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ close(); } });
  }

  /* Product thumbnail swap */
  var mainImg = document.getElementById('ProductMainImage');
  if(mainImg){
    document.querySelectorAll('.thumb').forEach(function(btn){
      btn.addEventListener('click',function(){
        mainImg.src = btn.getAttribute('data-full');
        document.querySelectorAll('.thumb').forEach(function(t){ t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* Widerruf two-step */
  function esc(str){ var d=document.createElement('div'); d.textContent=str; return d.innerHTML; }
  var wrForm = document.getElementById('WiderrufForm');
  if(wrForm){
    var s1 = wrForm.querySelector('[data-step="1"]');
    var s2 = wrForm.querySelector('[data-step="2"]');
    var nextBtn = wrForm.querySelector('[data-wr-next]');
    var backBtn = wrForm.querySelector('[data-wr-back]');
    var body = document.getElementById('WiderrufBody');
    var sum = document.getElementById('WiderrufSummary');
    if(nextBtn){
      nextBtn.addEventListener('click',function(){
        var name = wrForm.querySelector('[name="contact[Name]"]');
        var num = wrForm.querySelector('[name="contact[Bestellnummer]"]');
        var mail = wrForm.querySelector('[name="contact[email]"]');
        if(!name.value || !num.value || !mail.value){
          [name,num,mail].forEach(function(i){ if(!i.value && i.reportValidity){ i.reportValidity(); } });
          return;
        }
        var now = new Date();
        var ts = now.toLocaleString('de-DE');
        body.value = 'Widerruf gemaess §356a BGB\nName: '+name.value+'\nBestellnummer: '+num.value+'\nE-Mail: '+mail.value+'\nZeitpunkt: '+ts;
        sum.innerHTML = '<strong>Name:</strong> '+esc(name.value)+'<br><strong>Bestellnummer:</strong> '+esc(num.value)+'<br><strong>E-Mail:</strong> '+esc(mail.value)+'<br><strong>Zeitpunkt:</strong> '+esc(ts);
        s1.hidden = true; s2.hidden = false;
      });
    }
    if(backBtn){ backBtn.addEventListener('click',function(){ s2.hidden=true; s1.hidden=false; }); }
  }


  /* Product quantity stepper */
  document.querySelectorAll('.qty-stepper--input').forEach(function(box){
    var input = box.querySelector('.qty-input');
    box.querySelectorAll('.qty-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var step = parseInt(btn.getAttribute('data-qty'), 10) || 0;
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

})();
